import React, { useEffect, useRef, useState } from "react";
import Header from "../components/global/Header";
import LeftNavbar from "../components/global/LeftNavbar";
import RightModal from "../components/dashboard/RightModal";
import FilterProject from "../components/dashboard/FilterProject";
import ProjectTab from "../components/dashboard/ProjectTab";
import { useNavigate } from 'react-router-dom';
import { RotatingLines } from "react-loader-spinner";
import { dateDifference, getDepartmentObject, transformBlankToNull } from '../services/Util';
import { putAxiosResponse, getAxiosResponse , postAxiosResponse, logoutFunc} from "../services/authApiRoutes/APImethods";
import APIUrls from "../services/APIUrls";
import { useDispatch } from 'react-redux'
import {projectCreationStepFilter } from '../redux/reducers/ProjectCreationStepSlice';
import {  useTranslation } from 'react-i18next';
import { updateTargetLanguage } from "../redux/reducers/CreateProjectTargetLanguageSlice";
import { updateSourceLanguage } from "../redux/reducers/CreateProjectSourceLanguageSlice";
import { departmentSelected } from "../redux/reducers/CreateProjectDepartmentSelectSlice";
import { updateProjectFollowers } from "../redux/reducers/ProjectInfoSlice";
import { updateInitializedProjectWorkflows } from "../redux/reducers/InitializedProjectWorkflowsSlice";
import { updateProjectInfoConfiguration } from "../redux/reducers/ProjectInfoConfigurationSlice";
import { updateProjectInfoValidation } from "../redux/reducers/ProjectInfoValidationSlice";
import { updateProjectInfo } from "../redux/reducers/ProjectInfoSlice";
import { updateSourceFiles } from "../redux/reducers/SourceFilesSlice";
import { updateCustomerBootstrapData } from "../redux/reducers/CustomerBootstrapDataSlice";
import {  useSelector } from "react-redux";
import Constants from "../Constants";
import $, { each, event } from "jquery";
import { updateRightModelStatus } from "../redux/reducers/RightModelStatus";
import { getLoggedInUserRole, dateConvertToTimeStamp } from "../services/Util";
import { TourProvider } from "@reactour/tour";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import "@reactour/popover/dist/index.css";
import steps from "../services/tourJson/steps";
import { current } from "@reduxjs/toolkit";
import { Breadcrumb } from "../components/dashboard/Breadcrumb";
import ProjectCreationWithTemplate from "../components/project/ProjectCreationWithTemplate";
import { updateSelectedProjectWorkflow } from "../redux/reducers/SelectedProjectWorkflowSlice";
import { updateAllUserGroupFollowers, updateFollowersCollection } from "../redux/reducers/ProjectFollowersSlice";
import AppStartupPopups from "../components/AppStartupPopups";
import { FilterIcon, PlusIcon } from "../AppIcons";
import { ConditionalBlock } from '../ConditionalBlock';
import { updateAsyncUploadAssetCompletedFiles, updateAsyncUploadAssetInProgressFiles, updateAsyncUploadAssetPendingFiles, updateCanSubmitTranslation, updateReadyForValidation, updateValidationErrors} from "../redux/reducers/AsyncAssetUploadSlice";
import { updateBidRequestInfo } from "../redux/reducers/BidRequestSlice";
import { setSelectedTreeData } from "../redux/reducers/TreeSlice";


const Dashboard = (prop) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const translate = t;

  const [urlParameter,setUrlParameter]=useState(undefined);
  const [roles,setRoles]=useState([])
  const [url,setUrl]=useState(null);
  const [templates,setTemplates] = useState([]);
  const navigate = useNavigate();
  let department;
  let intendedUseId;
  let updateGlossaryTask;
  const roleArray = getLoggedInUserRole();
  const custBootstrapDataRedux = useSelector(store => store.customer_bootstrap_data).value;
  const getPermissions = useSelector(
    (rolePermissionSelected) => rolePermissionSelected.role_permission,
  ).value;


  useEffect(()=>{
    dispatch(updateReadyForValidation(false));
    getCurrentUser();
    getAllTemplates();
  },[])


  const getCurrentUser=async ()=>{
    if(!roleArray.includes('ROLE_VENDOR')){
    const result=await getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA);
    let bootstrapData = result?.data?.data;
    const dateTimestamp = dateConvertToTimeStamp();
    const orgresult = await getAxiosResponse(APIUrls.CUSTOMER_ORG_PREFERENCE_ALL + `?_=${dateTimestamp}`);
    if(orgresult !==undefined && orgresult !==null){
      try{
        if(bootstrapData !== undefined){
          bootstrapData.orgPreferences = orgresult?.data?.data;
        }
      }catch(err){
        console.info(err)
      }
      //storing in redux for reuse.
      dispatch(updateCustomerBootstrapData(bootstrapData))
      let data=result?.data?.data?.roleSet?.roleTypes.map(data=>Constants.ROLE_NAME+data.value)
      setRoles(result?.data?.data?.roleSet?.roleTypes.map(data=>data?.value))
      if(data && data?.length > 0){
        let urlParam=data?.join("")
        let  url=urlParam?.substring(1,urlParam?.length)
        setUrlParameter(url)
      }
      }
    }
  };

  const getAllTemplates = ()=>{
    getAxiosResponse(APIUrls.PROJECT_TEMPLATE+"?enabled=true")
    .then((response)=>{
        const data = response.data.data;
        let showData = data?.map(({name,id})=> ({label:name,value:id}));
        if(showData !== undefined){
          setTemplates(showData);
        }
    }).catch((err)=>{
        console.error(err);
    });
};

  useEffect(() => {
    document.title = "OPAL-Marketing | The Marketing Globalization Platform - Dashboard";
    document.body.classList.remove('login-body');
  });
  const[globalOverlay,showGlobalOverlay] = useState(false);

   const createProject = (event)=>{
    showGlobalOverlay(true);
    if(!roleArray.includes('ROLE_VENDOR')){
      if(custBootstrapDataRedux?.features?.USER_GROUPS){
        getAxiosResponse(APIUrls.DEPARTMENT_INCLUDE_SYSTEM_IF_POPULATED)
        .then((res) => {        
          if (res?.data?.code === 200) {   
          const allDepartments=res?.data?.data
            if(allDepartments && allDepartments.length){
              department=getDepartmentObject(allDepartments);
              getIntendedUseForProjectCreation();
            }                
          }
        }).catch(err=>{
          console.error(err)
        })
      }else{
          department = transformBlankToNull(custBootstrapDataRedux?.systemUserGroup);
          getIntendedUseForProjectCreation();
      }
    }
  };



  const openTemplateModal = ()=>{
    document.body.classList.add("modal-open-9");
  };

  const createRequest = () => {
    showGlobalOverlay(true);
    navigate("/project-request/create");
  }



  const getIntendedUseForProjectCreation =() =>{
    getAxiosResponse(APIUrls.INTENDED_USES_TASKS).then((res) => {
      if (res.data.code === 200) {
        const minimumIntendedUseId = Math.max(...res.data.data.map(x=>x.id))
        let selectedIntendedUse = res.data.data.find(intendedUse => intendedUse.id === minimumIntendedUseId);
        if(selectedIntendedUse?.tasks?.length !== 0) {
          let containsUpdateGlossaryTask = selectedIntendedUse?.tasks?.find(task => task?.projectTaskType?.type === Constants.TASK_UPDATE_GLOSSARY);
          containsUpdateGlossaryTask !== undefined ? updateGlossaryTask = {generalGlossary : "true" , termStatusOnCompletion : "approved"} : updateGlossaryTask = null;
        }
        intendedUseId = minimumIntendedUseId;
        triggerProjectCreation();
      }
     }).catch(err=>{
      console.error(err)
    })

  };

 const triggerProjectCreation = () =>{
  dispatch(updateSourceFiles([]));
  dispatch(updateAsyncUploadAssetPendingFiles({}))
  dispatch(updateAsyncUploadAssetCompletedFiles([]))
  dispatch(updateAsyncUploadAssetInProgressFiles([]))
  dispatch(updateValidationErrors([])) 
  dispatch(updateReadyForValidation(false));
  dispatch(updateCanSubmitTranslation(true)); 
  dispatch(updateBidRequestInfo({}));
  dispatch(setSelectedTreeData([]));
  postAxiosResponse(APIUrls.CREATE_PROJECT,{"status":"CONFIGURED_BASIC_PROJECT_INFO", 
  "projectFollowers":null,
  "projectUpdateGlossary": updateGlossaryTask,
  "name":"-----",
  "intendedUse": {
          "id": intendedUseId
      },
      "userGroup":department
      })
      .then((res) => {
          const projectId = res.data.data.id;
          let projectResource = transformBlankToNull(res.data.data);
          //deleted  this key as it was giving 400 
          delete projectResource["owner"];
          delete projectResource["projectFollowers"]; 
          if(projectResource["workspace"] && projectResource["workspace"]['workspaceMembers']){
            delete projectResource["workspace"]['workspaceMembers'];
          }          
          projectResource.name=`Project-${projectId}`;
          projectResource.intendedUse = {"id":projectResource.intendedUse.id};
          projectResource.targetLanguages = []
          putAxiosResponse(APIUrls.PROJECT(projectId), projectResource).then((res)=>{
            dispatch(projectCreationStepFilter("Source Material Step 1"))               
            dispatch(updateSourceLanguage({}));	
            dispatch(updateTargetLanguage([]));	   
            dispatch(departmentSelected(""));
            dispatch(updateInitializedProjectWorkflows([]));
            dispatch(updateSelectedProjectWorkflow({}));
            dispatch(updateProjectInfoValidation({}));
            dispatch(updateProjectInfoConfiguration({}));
            dispatch(updateProjectInfo({}));
            showGlobalOverlay(false)
            navigate(`/createProject/${projectId}`);
          });
      })
      .catch((err) => {
        console.error("Error post request");
      });
  };

  const navCampaignPage = (event) =>{
    navigate("/campaigns");
  };

  const filterFunction = () => {
    var element = document.getElementById("filterBtn");
    var element2 = document.getElementById("activeId");
    element.classList.toggle("show-flex");
    element2.classList.toggle("active");
    $('#activeId').attr('aria-expanded', function(_, attr) {
      return attr === 'false' ? 'true' : 'false';
    });
  };
  const scrollRef = useRef(null);

//Tutorial Tips start
  function doArrow(position, verticalAlign, horizontalAlign) {
    if (!position) {
      return {};
    }
   const width = 16;
    const height = 12;
    const color = "white";
    const isVertical = position === "top" || position === "bottom";
    const spaceFromSide = 10;
  
    const obj = {
      [`--rtp-arrow-${
        isVertical ? opositeSide[horizontalAlign] : verticalAlign
      }`]: height + spaceFromSide + "px",
      [`--rtp-arrow-${opositeSide[position]}`]: -height + 2 + "px",
      [`--rtp-arrow-border-${isVertical ? "left" : "top"}`]: `${
        width / 2
      }px solid transparent`,
      [`--rtp-arrow-border-${isVertical ? "right" : "bottom"}`]: `${
        width / 2
      }px solid transparent`,
      [`--rtp-arrow-border-${position}`]: `${height}px solid ${color}`
    };
    return obj;
  }
  const styles = {
    popover: (base, state) => {
     return {
        ...base,
       ...doArrow(state.position, state.verticalAlign, state.horizontalAlign),
       '--reactour-accent': '#154da1',
       };
    }
    
  };
  const opositeSide = {
    top: "bottom",
    bottom: "top",
    right: "left",
    left: "right"
 };
 const prevButton= ({ currentStep, setCurrentStep, steps }) => {
  const first = currentStep === 0
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).trigger('focus')
  $(`.tutorial-left-arr + div button`).each(
    function(index, item){
      $(item).attr('aria-label','Go to step ' + (index + 1))
    }
  )
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).attr('aria-label','current step '+ (parseInt(currentStep,10) + 1))
  return (
    <button aria-label="go to previous" disabled={first ? "disabled" : ""} className={first ? "tutorial-left-arr tutorial-disable" : "tutorial-left-arr"}
      onClick={() => {
        if (first) {
          setCurrentStep((s) => steps.length - 1)
        } else {
          setCurrentStep((s) => s - 1)
        }
      }}
    >
      <svg viewBox="0 0 18.4 14.4"><path d="M1.4 7.2h16M7.6 1L1.4 7.2l6.2 6.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10"></path></svg>
    </button>
  )
 };
 const nextButton= ({ currentStep, setCurrentStep, steps, stepsLength, setIsOpen }) => {
  const last = currentStep === stepsLength - 1
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).trigger('focus')
  $(`.tutorial-left-arr + div button`).each(
    function(index, item){
      $(item).attr('aria-label','Go to step ' + (index + 1))
    }
  )
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).attr('aria-label','current step '+ (parseInt(currentStep,10) + 1))
  return (
    <>
    {last ? (
      <button className="finish-btn"
        onClick={() => {
        if (last) {
          setIsOpen(false)
        } else {
          setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
        }
       }}
      >Finish</button>
    ) : (
      <button aria-label="go to next" disabled={last ? "disabled" : ""} className={last ? "tutorial-right-arr tutorial-disable" : "tutorial-right-arr"}
      onClick={() => {
        if (last) {
          setIsOpen(false)
        } else {
          setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
        }
       }}
      >
      <svg viewBox="0 0 18.4 14.4"><path d="M17 7.2H1M10.8 1L17 7.2l-6.2 6.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10"></path></svg>
      </button>
    )}
    </>
  )

 }
 const disableBody = (target) => disableBodyScroll(target)
 const enableBody = (target) => enableBodyScroll(target)
 const showModelTutorial = () =>{
   document.body.classList.add("modal-tutorial");
   $(".nextFocus").on("keydown", function (e) {
    if (e.key === Constants.TAB) {
      if (e.shiftKey === false) {
        e.preventDefault();
        $(".cancelFocus").trigger("focus");
      }
    }
  });
   setTimeout(() => {
    $(".cancelFocus").trigger("focus");
    $(".cancelFocus").on("keydown", function (e) {
      if (e.key === Constants.TAB) {
        if (e.shiftKey === true) {
          e.preventDefault();
          $(".nextFocus").trigger("focus");
        }
      }
    });
    $(".inner-lightbox-panel").on("keydown", function (e) {
      if (e.key === Constants.ESCAPE) {
        document.body.classList.remove("modal-tutorial");
        $('.focusAdd').trigger('focus');
        $('.tutorial-tips').removeClass('focusAdd');
      }
    });
  }, 500);
 
 }

  function showHide() {
    var element = document.getElementById("progress-btn");
    if(element !==undefined && element !==null){
      element.classList.toggle("show");
      $('.new-btn').attr('aria-expanded', function(index, attr){
        return attr === 'true' ? 'false': 'true';
      });
      $(document).mouseup(function(e) {
        var bannerCont = $('.name-card-section-right');
        if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
          showHide()
        }
      });
    }
  }
 //Tutorial Tips end
   return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper" >
        <TourProvider
          steps={steps}
          styles={styles}
          prevButton={prevButton}
          nextButton={nextButton}
          afterOpen={disableBody}
          beforeClose={enableBody}
          onClickMask={({ currentStep, steps, setIsOpen }) => {
            if (steps) {
              if (currentStep === steps.length) {
                setIsOpen(true);
               }
              }
          }}
          badgeContent={({ totalSteps, currentStep }) => currentStep + 1 + "/" + totalSteps}>
          <Header ref={scrollRef} func={showModelTutorial}/>
          <LeftNavbar />
        </TourProvider>
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap"  >
           <div className="dashboard-top flex-center">
              <div className="flex-left flex-center">
                <div className="group-btn flex-center" role="tablist">
                  <button id="projectBtn"
                   className="active dashboard-btn"
                   role="tab"
                   aria-label={'Current tab ' + translate('projects')}
                   aria-selected="true"
                  >{translate('projects')}</button>
                  <ConditionalBlock condition={custBootstrapDataRedux?.features?.PROJECT_WORKSPACES}>
                    {getPermissions.includes('CAMPAIGN_DASHBOARD') ? (
                      <button id="campaignBtn" className="dashboard-btn" onClick={navCampaignPage}
                        role="tab"
                        aria-label={translate('campaigns')}
                        aria-selected="false"
                      >{translate('campaigns')}</button>
                      ) : null}
                  </ConditionalBlock>
                </div>
                <div className="fliter">
                  <button id="activeId" className="dashboard-btn" onClick={filterFunction} data-tour="dashboard-filter" aria-expanded="false">
                    <span className="filter-icon">
                      {FilterIcon}
                    </span>{" "}
                    {translate('filters')}
                  </button>
                </div>
              </div>
              <div className="flex-right flex-center btn-gap10">
                {getPermissions.includes('CREATE_PROJECT')? (
                  <>
                  <ConditionalBlock condition={templates?.length === 0}>
                    <button className="dashboard-btn" onClick={createProject}>
                    {PlusIcon} New {translate('new_project')}
                    </button>
                  </ConditionalBlock>
                  <ConditionalBlock condition={templates?.length>0}>
                    <div className="name-card-section-right ">
                      <div className="projectDeatilsDot" onClick={showHide}
                          role="button" aria-label="Task Type" aria-expanded="false" tabIndex="0" projectdetail-tour="clone-project" >
                        <button className="dashboard-btn" >
                          {PlusIcon} Start New
                        </button>
                      </div>
                      <div className="progress-btn min-width-190" id="progress-btn" >
                          <div className="inner-popover project-btn">
                            <button className="dashboard-btn" onClick={createProject}>
                              {translate('new_project')}
                            </button>
                            <button className="dashboard-btn" onClick={openTemplateModal}>
                              {translate('new_project_with_template')}
                            </button>
                          </div>
                      </div>
                    </div>
                  </ConditionalBlock>
                  </>
                 ) :null }
                 <ConditionalBlock condition={custBootstrapDataRedux?.edition === "ENTERPRISE"}>
                  {getPermissions.includes('CREATE_PROJECT_REQUEST')? (
                  <button className="dashboard-btn" onClick={createRequest}>
                    {PlusIcon}
                    Create Project Request
                  </button>
                  ) :null }
                 </ConditionalBlock>
              </div>
            </div>
            <div>&nbsp;</div>
            <FilterProject filter={prop.filterType}/>
            <ProjectTab />
          </div>
        </section>
      </div>

      <AppStartupPopups/>

      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>
      <div className="overlay"></div>
      <RightModal />
      <ProjectCreationWithTemplate templates={templates}/>
   </div>
    
  );
};

export default Dashboard;
